export default __webpack_public_path__ + "static/media/fbd0336624acaaa5.e68f4848b93bac75d3cc2168a4acca9d.svg";